import { logGreyErrorFromAccounts } from 'owa-account-analytics';

/**
 * The list of known error stacks that have been logged. We maintain this list so that we don't log
 * the same error multiple times.
 */
const knownErrorStacks = new Set<string>();

export function resetKnownErrorStacks(): void {
    knownErrorStacks.clear();
}

export enum ActionExecution {
    Synchronous = 'Synchronous',
    Asynchronous = 'Asynchronous',
}

/**
 * Attempts to run the action synchronously, if it fails, it will attempt to run the action
 * asynchronously to get it to complete.
 * @param name The name of the action
 * @param action The action to run
 */
export function runActionWithAsyncFallback(
    name: 'Archive' | 'Groups' | 'PublicFolders' | 'SharedMailboxes' | 'Teams' | 'TeamRhythm',
    action: () => void
): ActionExecution {
    try {
        action();
        return ActionExecution.Synchronous;
    } catch (err) {
        if (err instanceof Error) {
            const stack = err.stack;
            if (!!stack && !knownErrorStacks.has(stack)) {
                knownErrorStacks.add(stack);

                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 *	> Argument at index 1 for logGreyErrorFromAccounts must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
                logGreyErrorFromAccounts('ExceptionRunningAction', undefined, err, { name });
            }
        }
    }

    // Attempt to run the action asynchronously, this is to handle the case where the
    // action failed because we are already within an action
    setTimeout(() => {
        try {
            action();
        } catch (err) {
            if (err instanceof Error) {
                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 *	> Argument at index 1 for logGreyErrorFromAccounts must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
                logGreyErrorFromAccounts('ExceptionRunningActionAsync', undefined, err, { name });
            }
        }
    }, 0);

    return ActionExecution.Asynchronous;
}
